import { forwardRef, Ref, useState } from "react";
import { FieldValues,Path,UseControllerProps, UseFormSetValue } from "react-hook-form";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { Editable, Slate, withReact } from "slate-react";
import { toHtml, toSlateJson } from '../../shared/components/editor/utils/serializers';
import { Box } from "../../shared/components/widgets/Box";
import { Toolbar } from "../../shared/components/editor/Toolbar";
import { RenderElement, RenderLeaf } from "../../shared/components/editor/Renders";
import '../../shared/components/editor/styles/editor-styles.css'
import { Faq } from "../../faq/faqSlice";


/*
  This component is a Slate Editor wrapped as a react-hook-form textarea. Part of that wrapping inclides the redux state for whatson.body
  The Redux state is also injected for the fileUpload function.

  Its taken a while to understand Slate's transformation sequence:

  1. The editable content (whatson.body) is stored in DynamoDB as html
  2. this html is fed into this component via "prop.value"
  3. it is translated to Slate JSON format via toSlateJson (wrapping deserialize)
  4. as the Slate JSON is passed into "initialValue" it gets rendered via callbacks:
          renderElement={RenderElement}
          renderLeaf={RenderLeaf}
      from Slate JSON into the editable field's html representation (so the user can see whatson.body as it would appear as site content)
  
  5. whenever a change occurs, handleChange fires off
    i. it filters out irrelevant change events
    ii. the slateToHtml serializer fires off,converting the Slate JSON nodes into html
    iii. react-hook-form's setValue updates the form state and the form's onChange event is fired off

  The next complication is inserting images into the editable area.
  We need 
  1. Slate JSON model for the image
  2. the html representation (both for display and for storage as part of whatson.body)
*/
interface EditorBodyFieldProps<T extends FieldValues>
    extends UseControllerProps<T> {
      name: Path<T>,
      label: string,
      value: string,
      error: string | undefined,
      onBlur: any,
      onChange: any
}
export const FaqEntryEditor = forwardRef(<T extends FieldValues>( props: {
  name: Path<T>,
  label: string,
  value: string,
  setValue: UseFormSetValue<Faq>,
  error: string | undefined,
  onBlur: any,
  onChange: any
} & EditorBodyFieldProps<T>, ref:Ref<HTMLDivElement>) => {


  const [editor] = useState(() => withHistory(withReact(createEditor())))

  const {isVoid, isInline} = editor;

  // override isVoid for images
  editor.isVoid = (el) => el.type === 'image' || isVoid(el)

  // override isInline for links, so that they don't end up in their own paragraphs
  editor.isInline = element =>
    ['link'].includes(element.type) || isInline(element)
  
  console.log(props.value)
  const initialValue = (props.value) ? toSlateJson(props.value) : toSlateJson('<p></p>');


  /**
   * <li>Accept the slate format value for the whole content</li>
   * <li>Serialise it</li>
   * <li>update the props.value with serialised value</li>
   * <li>call props.onChange with serialised value</li>
   * @param fieldValue 
   */
  const handleChange = (fieldValue: any) => {

    const isAstChange = editor.operations.some(
      op => 'set_selection' !== op.type
    )
    if (isAstChange) {
      console.log(fieldValue);
      
      // serialise
      const htmlValue = toHtml(fieldValue)
      console.log(htmlValue);
       
      // update react-hook-form value
      //  props.value = htmlValue;
      props.setValue('answer', htmlValue);
      // call react-hook-form on change with new value 
      props.onChange(htmlValue);
            
    }
  }

  // const handleNodeRemove = () => {
  //   Transforms.removeNodes(editor, { at: path })
  // }

  const handleError = (error: any) => {
    console.error(error);
  }
  
  return (

    <Slate editor={editor} onChange={e => handleChange(e)} initialValue={initialValue} >
      <label htmlFor={props.label} className='form-label'>
        {props.label}
      </label>
      <Box
        position="sticky"
        width="100%"
        bgColor="white"
        zIndex="10"
        btlRad="10px"
        btrRad="10px"
        boxShadow='0 1px 3px rgba(64, 64, 64, 0.5)'
        p='2px'
      >
        <Toolbar />

      </Box>
      <Box
        bgColor='EDF2F6'
        bblRad='10px'
        bbrRad='10px'
        boxShadow='0 1px 3px rgba(64, 64, 64, 0.5)'
        mb='1rem'
      >

        <Editable 
          className='editor-input'
          ref={ref}
          renderElement={RenderElement}
          renderLeaf={RenderLeaf}
          autoFocus
          placeholder="Write something..."
          // onKeyDown={event => {
          //   console.log(event.key)
          // }}
        />
      </Box>
      
    </Slate>
)});



